export default "__VITE_ASSET__x9nAjPEY__"